// fields/renderSwitchField.tsx
import { Grid, FormControlLabel, Switch } from "@mui/material";
import { ToolbarFieldConfig, TFilterFieldsLocal } from "../ToolbarSinisterGeneric";

type Props = {
	field: ToolbarFieldConfig;
	filters: TFilterFieldsLocal;
	setFilter: (key: string, value: any) => void;
};

export function renderSwitchField({ field, filters, setFilter }: Props) {
	const value = filters[field.key] ?? 0;

	return (
		<Grid item key={field.key}>
			<FormControlLabel
				control={
					<Switch
						checked={value === 1}
						onChange={(e) => {
							const newValue = e.target.checked ? 1 : 0;
							setFilter(field.key, newValue);
							field.onChange?.(newValue, filters, setFilter);
						}}
						sx={{ ml: 2, mr: 1 }}
					/>
				}
				label={field.label}
				{...field.extraProps}
			/>
		</Grid>
	);
}
